import { Application } from "@hotwired/stimulus";

import Modal from "javascripts/controllers/modal_controller";
import Flash from "javascripts/controllers/flash_controller";

window.Stimulus = Application.start();
Stimulus.register("modal", Modal);
Stimulus.register("flash", Flash);
